module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('v-dialog'), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "modal-confirm",
      "classes": ['v--modal', 'modal-confirm'],
      "pivot-y": 0.2,
      "width": 400,
      "height": 125
    }
  }, [_c('div', {
    staticClass: "confirm-modal-content"
  }, [_c('div', {
    staticClass: "modal-title"
  }, [_c('h6', [_vm._v("Voulez-vous désactiver le client "), _c('b', [_vm._v(_vm._s(this.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.$modal.hide('modal-confirm')
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.destroy
    }
  }, [_vm._v("Confirmer")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row main-wrap"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-7"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "section-bg"
  }, [_c('div', {
    staticClass: "create-btn ",
    attrs: {
      "id": "filter-form-container"
    }
  }, [_c('button', {
    staticClass: "green-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-folder-open",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\t\t\t\tNouveau\n\t\t\t\t\t")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.allClients), function(client) {
    return _c('tr', {
      key: client.id,
      staticClass: "table-row",
      on: {
        "click": function($event) {
          return _vm.fill(client, $event)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(client.user.name))]), _vm._v(" "), _c('td', [(client.entite.length > 0) ? _c('ul', _vm._l((client.entite), function(entite) {
      return _c('li', [_vm._v(_vm._s(entite.name))])
    }), 0) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.nbjour))]), _vm._v(" "), _c('td', [(client.utilisateur !== null) ? _c('ul', _vm._l((client.utilisateur), function(utilisateur) {
      return _c('li', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(utilisateur.user.name) + " " + _vm._s(utilisateur.user.surename) + "\n\t\t\t\t\t\t\t\t\t")])
    }), 0) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.solde))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-5"
  }, [_vm._m(3), _vm._v(" "), (_vm.display) ? _c('div', {
    staticClass: "section-bg default-form"
  }, [_vm._m(4)]) : _c('div', {
    staticClass: "section-bg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nom")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap form-group col-sm-6"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.removeUser),
      expression: "removeUser"
    }],
    attrs: {
      "id": "check",
      "type": "checkbox",
      "name": "check",
      "value": "check"
    },
    domProps: {
      "checked": Array.isArray(_vm.removeUser) ? _vm._i(_vm.removeUser, "check") > -1 : (_vm.removeUser)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.removeUser,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "check",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.removeUser = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.removeUser = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.removeUser = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "check"
    }
  }, [_vm._v("Désactiver le profil")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12 input_fields_wrap entites-wrap"
  }, [_c('label', {
    attrs: {
      "for": "entite"
    }
  }, [_vm._v("Entité")]), _vm._v(" "), (_vm.entites.length === 0 && _vm.new_entites.length === 0) ? _c('div', {
    staticClass: "row mb"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "add_field_button grey-button",
    on: {
      "click": _vm.addEntite
    }
  }, [_vm._v("+")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.entites), function(entite, index) {
    return _c('div', {
      staticClass: "row mb"
    }, [_c('div', {
      staticClass: "col-xs-8"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (entite.name),
        expression: "entite.name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "required": ""
      },
      domProps: {
        "value": (entite.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(entite, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('button', {
      staticClass: "remove_field_button grey-button",
      on: {
        "click": function($event) {
          return _vm.removeEntite(index)
        }
      }
    }, [_vm._v("-")]), _vm._v(" "), (index === (_vm.entites.length + _vm.new_entites.length) - 1) ? _c('button', {
      staticClass: "add_field_button grey-button",
      on: {
        "click": _vm.addEntite
      }
    }, [_vm._v("+")]) : _vm._e()])])
  }), _vm._v(" "), _vm._l((_vm.new_entites), function(new_entite, index) {
    return _c('div', {
      staticClass: "row mb"
    }, [_c('div', {
      staticClass: "col-xs-8"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (new_entite.value),
        expression: "new_entite.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (new_entite.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(new_entite, "value", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('button', {
      staticClass: "remove_field_button grey-button",
      on: {
        "click": function($event) {
          return _vm.removeNewEntite(index)
        }
      }
    }, [_vm._v("-")]), _vm._v(" "), (index === _vm.new_entites.length - 1) ? _c('button', {
      staticClass: "add_field_button grey-button",
      on: {
        "click": _vm.addEntite
      }
    }, [_vm._v("+")]) : _vm._e()])])
  })], 2)]), _vm._v(" "), _c('hr', {
    staticClass: "hr-text",
    attrs: {
      "data-content": "vendu au client"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nbheure),
      expression: "nbheure"
    }],
    staticClass: "form-control",
    class: {
      disabled1: _vm.disabled
    },
    attrs: {
      "type": "number",
      "min": "1",
      "id": "nbheure",
      "disabled": _vm.disabled1 == 1 ? true : false,
      "required": ""
    },
    domProps: {
      "value": (_vm.nbheure)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nbheure = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "center",
    attrs: {
      "for": "nbheure"
    }
  }, [_vm._v("Heures facturées par jour")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nbjour),
      expression: "nbjour"
    }],
    staticClass: "form-control",
    class: {
      disabled2: _vm.disabled
    },
    attrs: {
      "type": "number",
      "min": "1",
      "id": "nbjour",
      "disabled": _vm.disabled2 == 1 ? true : false,
      "required": ""
    },
    domProps: {
      "value": (_vm.nbjour)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nbjour = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "center",
    attrs: {
      "for": "nbjour"
    }
  }, [_vm._v("Jours vendus par mois")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.soldeCompteTemps),
      expression: "soldeCompteTemps"
    }],
    staticClass: "form-control",
    class: {
      disabled3: _vm.disabled
    },
    attrs: {
      "type": "number",
      "min": "1",
      "id": "temps",
      "disabled": _vm.disabled3 == 1 ? true : false,
      "required": ""
    },
    domProps: {
      "value": (_vm.soldeCompteTemps)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.soldeCompteTemps = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "center",
    attrs: {
      "for": "temps"
    }
  }, [_vm._v("Solde du compte-temps")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 text-center"
  }, [(_vm.disabled1 == true) ? _c('span', {
    staticClass: "update",
    on: {
      "click": _vm.modifyHeure
    }
  }, [_vm._v("Modifier")]) : _vm._e(), _vm._v(" "), (_vm.disabled1 == false) ? _c('span', {
    staticClass: "update",
    on: {
      "click": _vm.cancel_modifyHeure
    }
  }, [_vm._v("Annuler")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-center"
  }, [(_vm.disabled2 == true) ? _c('span', {
    staticClass: "update",
    on: {
      "click": _vm.modifyMois
    }
  }, [_vm._v("Modifier")]) : _vm._e(), _vm._v(" "), (_vm.disabled2 == false) ? _c('span', {
    staticClass: "update",
    on: {
      "click": _vm.cancel_modifyMois
    }
  }, [_vm._v("Annuler")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-center"
  }, [(_vm.disabled3 == true) ? _c('span', {
    staticClass: "update",
    on: {
      "click": _vm.modifyTemps
    }
  }, [_vm._v("Modifier")]) : _vm._e(), _vm._v(" "), (_vm.disabled3 == false) ? _c('span', {
    staticClass: "update",
    on: {
      "click": _vm.cancel_modifyTemps
    }
  }, [_vm._v("Annuler")]) : _vm._e()])]), _vm._v(" "), _c('hr', {
    staticClass: "hr-text",
    attrs: {
      "data-content": "repartition des jours vendus"
    }
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.adduser.length === 0) ? _c('div', {
    staticClass: "row mb"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('button', {
    staticClass: "add_field_button grey-button",
    on: {
      "click": _vm.addUtilisateur
    }
  }, [_vm._v("+")])])]) : _vm._e(), _vm._v(" "), (_vm.adduser != undefined) ? _c('div', _vm._l((_vm.adduser), function(userAdd, index) {
    return _c('div', [(_vm.adduser.length === 0 && _vm.disabled === 0) ? _c('div', {
      staticClass: "row mb"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(index === _vm.adduser.length - 1) ? _c('button', {
      staticClass: "add_field_button grey-button",
      on: {
        "click": _vm.addUtilisateur
      }
    }, [_vm._v("+")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row mb"
    }, [_c('div', {
      staticClass: "col-xs-8"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-8"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (userAdd.id),
        expression: "userAdd.id"
      }],
      attrs: {
        "placeholder": "Choose here"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(userAdd, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.selectPerson()
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "Choisir une personne assignee",
        "selected": ""
      }
    }, [_vm._v("Choisissez une personne assignée")]), _vm._v(" "), _vm._l((_vm.allUsers), function(user) {
      return _c('option', {
        domProps: {
          "value": user.id
        }
      }, [_vm._v(_vm._s(user.user.name))])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (userAdd.temps.temps),
        expression: "userAdd.temps.temps"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": "1",
        "id": "jours"
      },
      domProps: {
        "value": (userAdd.temps.temps)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(userAdd.temps, "temps", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4"
    }, [_c('button', {
      staticClass: "remove_field_button grey-button",
      on: {
        "click": function($event) {
          return _vm.removeUtilisateur(index)
        }
      }
    }, [_vm._v("-")]), _vm._v(" "), (index === _vm.adduser.length - 1) ? _c('button', {
      staticClass: "add_field_button grey-button",
      on: {
        "click": _vm.addUtilisateur
      }
    }, [_vm._v("+")]) : _vm._e()])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "submit-btn"
  }, [_c('button', {
    staticClass: "green-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Sauvegarder")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', [_c('h1', [_vm._v("Gestion des Clients"), _c('i', {
    staticClass: "fa fa-refresh fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onglet"
  }, [_c('h3', [_vm._v("Liste des clients")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-toggle": "true"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tNom du client\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "x-small small medium large"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEntité\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-type": "number"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tJours vendus par mois\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v("Répartition")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-type": "number",
      "data-breakpoints": "x-small medium"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSolde du compte-temps\n\t\t\t\t\t\t\t")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onglet"
  }, [_c('h3', [_vm._v("Profil du client")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ligne"
  }), _vm._v(" "), _c('p', [_vm._v("Créer modifier ou suprimer un client")]), _vm._v(" "), _c('div', {
    staticClass: "ligne"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('label', {
    attrs: {
      "for": "utilisateur"
    }
  }, [_vm._v("Personnes assignées")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "jours"
    }
  }, [_vm._v("Jours")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-348433f3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/components/Clients.vue
// module id = 200
// module chunks = 0